import { Directive, Input, ViewContainerRef } from '@angular/core';
import { UploadFileComponent } from 'src/app/components/upload-file/upload-file.component';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { RootMenuItem } from 'src/models/Menu';

@Directive({
    selector: '[asgComponentBuilder]',
    standalone: true
})
export class ComponentBuilderDirective {
  @Input() componentData: RootMenuItem['componentData'] | null = null;
  @Input() feature: AsgardFeatureNames;
  @Input() set BuildComponent(_e: UploadFileComponent) {
    const componetRef = this.viewContainerRef.createComponent(UploadFileComponent);
    if (this.componentData) {
      for (const key in this.componentData) {
        if (key) {
          componetRef.instance[key] = this.componentData[key];
        }
      }
      componetRef.instance['feature'] = this.feature;
    }
  }
  constructor(
    private viewContainerRef: ViewContainerRef
  ) { }

}
